'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('HubStyleTokens/colors');

exports.default = {
  'candy-apple': _colors.CANDY_APPLE,
  calypso: _colors.CALYPSO,
  koala: _colors.KOALA,
  lorax: _colors.LORAX,
  marigold: _colors.MARIGOLD,
  norman: _colors.NORMAN,
  oz: _colors.OZ,
  sorbet: _colors.SORBET,
  thunderdome: _colors.THUNDERDOME
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/core/NormalColors.js
// module id = 516
// module chunks = 177